import styled from "../../__compat__/styled-components/main.entry.mjs.mjs";
export const StyledNotificationList = styled.ul.withConfig({ displayName: "auir-611444a-StyledNotificationList", componentId: "auir-611444a-1cuy17j" }) `
  list-style-type: none;
  padding: 0;
  margin: 0;
  display: flex;
  gap: var(${(props) => props.theme.responsive.spacing.m});
  flex-direction: column;
`;
//# sourceMappingURL=NotificationList.styles.mjs.mjs.map